import styled from "styled-components";
import { mapColor } from "../../utils/colorUtils";

export const OuterWrapper = styled.div`
  display: flex;
  padding-top: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  max-width: 865px;
  margin: 0 auto;

  border-radius: 12px;
  border: 1px solid var(--Colors-Neutral-300, #e9ecef);
  background: var(--Colors-Neutral-100, #fff);

  box-shadow: 0px 10px 16px 0px rgba(230, 230, 230, 0.25);

  // overflow: scroll;
  // height: 100%;
  margin-top: 8px;
  margin-bottom: 8px;

  @media print {
    width: auto !important;
    max-width: none !important;
    overflow: visible !important;
    height: auto !important;
    background: none !important;
    box-shadow: none !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    border-radius: 0 !important;
  }
`;

/* The heading that includes an SVG with text overlay */
export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  // padding: 40px;
  width: 100%;
  border-radius: 12px;

  @media print {
    overflow: visible !important;
    background: none !important;
    border: none !important;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    padding: 16px;
    gap: 16px;
  }
`;

export const HeaderOverlay = styled.div`
  display: inline-flex;
  padding-top: 22px;
  align-items: center;

  opacity: 0.2;
  color: #196e74;
`;

export const SVGContainer = styled.div`
  position: relative;
  overflow: hidden; /* Ensures any overflow is hidden */
  border-radius: 12px;
  padding: 45.659px 0px 17.27px 0px;
  background: var(--Colors-Secondary-200, #b8ebef);

  svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media print {
    overflow: visible !important;
  }
`;

/* Absolutely-positioned text overlay */
export const TextOverlay = styled.div`
  max-width: 60%;

  @media (max-width: 480px) {
    max-width: 100%;
  }
`;

export const TextContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  color: #104346; /* or neutral-700, etc. */
  width: 335px;

  h2 {
    width: 335px;
  }

  @media (max-width: 480px) {
    // width: auto;
    max-width: 100%;
  }
`;

export const BottomTextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 60px;
`;

export const BottomTextColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  @media print {
   p.body-text-small.medium.secondary-700 {
      color: #004F96 !important;  /* ← whatever “print” color you want */
    }
`;

export const BodyContainer = styled.div`
  padding-left: 24px;
  padding-right: 24px;
`;

export const SectionContainer = styled.div`
  margin-bottom: 32px;

  @media print {
    ${({ $isFirst }) =>
      !$isFirst &&
      `
        page-break-before: always;
        break-before: page;
      `}
  }
`;

export const SectionTitle = styled.div`
  padding: 16px;
  border-radius: 12px;
  background-color: ${(props) =>
    mapColor(props.color || "#3A70E2").backgroundColor};
  h4 {
    color: ${(props) => mapColor(props.color || "#3A70E2").fontColor};
  }
`;

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ItemCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const ItemCard = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  padding: 16px;
  gap: 16px;

  border-radius: 12px;
  border: 1px solid var(--Colors-Neutral-400, #ced4da);

  /* Avoid splitting across pages if possible */
  @media print {
    page-break-inside: avoid;
  }
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
`;

export const QRCodeWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;

  img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    margin-right: 4px; /* Add margin-right here */
  }
`;

export const QRCodeLabel = styled.p`
  font-size: 14px;
  color: #6c757d;
`;

export const HeaderQRContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 480px) {
    align-self: center;
  }
`;

export const HeaderQRCodeLabel = styled.div`
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: 200px;

  p {
    text-align: center;
  }

  @media print {
  p {
  color: #004f96 !important; /* ← whatever “print” color you want */
  }
`;

export const HrLine = styled.div`
  width: 100%;
  flex-shrink: 0;
  height: 1px;
  background-image: repeating-linear-gradient(
    to right,
    #ccc,
    #ccc 10px,
    transparent 5px,
    transparent 25px
  );

  @media print {
    page-break-inside: avoid;
  }
`;

export const ImportantInfoContainer = styled.div`
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #ec2d30;
  background: rgba(236, 45, 48, 0.05);

  @media print {
    background: none !important;
    page-break-inside: avoid;
    border: none !important;
    padding: 0 !important;

    page-break-before: always;
    break-before: page;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const ContributersWrapper = styled.div`
  display: flex;
  padding: 0px 24px 24px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  background: var(--Colors-Neutral-200, #f8f9fa);

  @media print {
    background: none !important;
    // margin-top: -24px !important;
  }
`;

export const Contributers = styled.div`
  display: flex;
  padding: 24px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;

  @media print {
    padding: 0 !important;
    gap: 16px !important;
  }
`;

export const PeopleContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

export const PeopleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-self: stretch;
`;

export const UserCard = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: calc(33.33% - 16px); // 3 per row with gap
  min-width: 200px; // Minimum width for each card

  @media (max-width: 768px) {
    width: calc(50% - 12px); // 2 per row on smaller screens
  }

  @media (max-width: 480px) {
    width: 100%; // 1 per row on mobile
  }
`;

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const DigitalOnly = styled.div`
  /* on screen, render normally */
  display: block;

  /* in print, hide it */
  @media print {
    display: none !important;
  }
`;

export const PrintOnly = styled.div`
  /* on screen, hide */
  display: none;

  /* in print, show */
  @media print {
    display: block !important;
  }
`;
